import { CalendarToday } from '@mui/icons-material';
import { TextField, InputAdornment } from '@mui/material';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parseISO } from 'date-fns';
import { de, enUS, tr } from 'date-fns/locale';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from 'src/store/Store';

const Cm_DateTimePicker = ({ key, date, setDate, readOnly = false, label, disableFuture = true, required = false, hideIcon = false, styling = {} }: any) => {
  const handleDateChange = (newDate: any | null) => {
    if (newDate) {
      const tzoffset = new Date().getTimezoneOffset() * (language === 'tr' ? 1 : 1); /* 6000 */
      const localISOTime = new Date(newDate - tzoffset).toISOString().slice(0, -1) + 'Z';
      setDate(localISOTime);
    } else {
      setDate(null);
    }
  };
  // Translations
  const language_redux = useSelector((state: AppState) => state.customizer.isLanguage);
  const [language, setLanguage] = useState(language_redux);

  useEffect(() => {
    setLanguage(language_redux);
  }, [language_redux]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={language === 'tr' ? tr : enUS}>
      <DateTimePicker //
        key={key}
        value={date ? parseISO(date) : null}
        onChange={(newValue: any | null) => handleDateChange(newValue)}
        readOnly={readOnly}
        disableFuture={disableFuture}
        label={label ? (required ? label + ' *' : label) : null}
        slots={{
          textField: TextField,
        }}
        slotProps={{
          textField: {
            sx: {
              '& .MuiInputBase-input': { paddingRight: 0 },
              width: '100%',
              fontSize: '10px',
              ...(styling || {}),
            }
          }
        }}
        // slots={
        //   hideIcon
        //     ? undefined
        //     : {
        //         textField: (params) => (
        //           <TextField
        //             {...params}
        //             InputProps={{
        //               ...params.InputProps,
        //               endAdornment: (
        //                 <InputAdornment position="end">
        //                   <CalendarIcon sx={{ padding: '4px' }} />
        //                 </InputAdornment>
        //               ),
        //             }}
        //             sx={{ width: '100%' }}
        //           />
        //         ),
        //       }
        // }
      />
    </LocalizationProvider>
  );
};

export default Cm_DateTimePicker;
